// The canvas consumes its first-save handoff on mount. Router v1.170 reuses
// identical route components by default, so each draft needs its own identity.
export function studioCanvasRemountDeps({
  params,
}: {
  params: { scenarioId?: string }
}) {
  return params.scenarioId ?? "create"
}
